import { render, staticRenderFns } from "./IcFalse.vue?vue&type=template&id=97951e76&scoped=true"
import script from "./IcFalse.vue?vue&type=script&lang=js"
export * from "./IcFalse.vue?vue&type=script&lang=js"
import style0 from "./IcFalse.vue?vue&type=style&index=0&id=97951e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97951e76",
  null
  
)

export default component.exports